import React from 'react';

const ArtistContentMainTitle = (props:any) => {
const artistTitle = props.artistTitle;

return (
        <div className={'text-gray-450 mb-2'} data-grid-artist-title="true">
            {artistTitle}
        </div>
    )
}

export default ArtistContentMainTitle;